// @ts-nocheck
import cx from "classix";

export function Container({ className, ...props }) {
  return (
    <div
      className={cx("mx-auto max-w-8xl px-4 sm:px-6 lg:px-8", className)}
      {...props}
    />
  );
}
